import { createElement } from 'react';
import { string, node, any } from 'prop-types';
import { b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import _Navigation from './Navigation/styled.js';

var Navigation = function Navigation(_ref) {
  var a11yTitle = _ref.a11yTitle,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yTitle", "children"]);

  return (// @ts-ignore
    createElement(_Navigation, _extends({
      "aria-label": a11yTitle
    }, props, {
      role: props.use ? 'navigation' : props.role
    }), children)
  );
};

var navigationPropTypes = {
  a11yTitle: string,
  children: node.isRequired,
  className: string,
  role: string,
  use: any
};
Navigation.propTypes = navigationPropTypes;
var navigationDefaultProps = {
  a11yTitle: undefined,
  className: undefined,
  role: undefined,
  use: undefined
};
Navigation.defaultProps = navigationDefaultProps;
var C = Navigation;
export { C as a, navigationPropTypes as b, navigationDefaultProps as c };